/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from '../toast';
import * as userService from '../../../services/userService'
import { BASE_IMAGE_PATH } from '../../../configs/api';
class ClientParentSharingModel extends Component {
   constructor(props) {
      super(props);
      this.state = {
         sharingData:[],
         loading:false
      };
   }
   componentDidMount() {
      this.submitData();
   }
   submitData() {
         this.setState({loading:true},async()=>{
            userService.getClientParentSharing(this.props.selectedUsername).then((res) => {
               setTimeout(()=>{ this.setState({loading:false})},1000)
               if (res.isSuccess) {
                  this.setState({loading:false, sharingData: res.items})
               } else {
                  this.props.notify(res.message,"error");
                  this.setState({loading:false})
               }
            })
         })
   }
   change(e) {
      const name = e.target.name;
      let value = e.target.value;
      this.setState({ [name]: value })
   }
   render() {
      return (
         <>
            <div className="modal fade show" style={{ display: 'block' }} id="myParentSharing" role="dialog" aria-modal="true">
               <div className="modal-dialog modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h4 className="modal-title">Sharing Details</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.props.closePopup() }}>×</button>
                     </div>
                     <div className="modal-body lst-pop pt-0">
                        <div>
                           {
                              this.state.loading ? 
                              <span>Loading...</span>
                              :
                              this.state.sharingData.length > 0 ? 
                              <>
                                 <table id='example' className='table table-striped table-bordered table-sm addpadding nowrap w-100 mt-2 mb-2' >
                                 <thead>
                                    <tr>
                                       <th>
                                          Parent
                                       </th>
                                       <th>
                                          Sharing
                                       </th>
                                    </tr>
                                 </thead>
                                    <tbody>
                                       {this.state.sharingData.map((usr, i)=>{
                                          return(
                                             <tr key={`sharing_${i}`}>
                                                <td><span>{usr.username}</span></td>
                                                <td><span>{usr.sharing}</span></td>
                                             </tr>
                                          )
                                       })
                                       }
                                    </tbody>
                                 </table>
                              </>
                              :
                              <span>No Data Found.</span>

                           }
                        </div>
                     </div>
                     
                     {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.props.closePopup() }}></div>
               </div>            
         </>
      )
   }
}

function mapStateToProps(state) {
   return {
   };
}

function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(ClientParentSharingModel);